export default "__VITE_ASSET__CTTC_Bnw__"